import { useEffect } from "react";

const STORAGE_KEY = "APP_VERSION";

/**
 * Polls `/<filename>` (written by scripts/generate-build-meta.js at build time)
 * and, when the deployed version differs from the one this tab loaded with,
 * clears the Cache Storage and reloads so the user picks up the new build.
 * Replaces the unmaintained react-clear-cache package.
 */
export function useClearCache({ duration = 60000, filename = "build.json" } = {}) {
  useEffect(() => {
    let cancelled = false;

    const check = async () => {
      try {
        const res = await fetch(`${process.env.PUBLIC_URL || ""}/${filename}?t=${Date.now()}`, { cache: "no-store" });
        if (!res.ok) return;
        const { version } = await res.json();
        if (!version || cancelled) return;

        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored === null) {
          localStorage.setItem(STORAGE_KEY, String(version));
          return;
        }
        if (stored !== String(version)) {
          localStorage.setItem(STORAGE_KEY, String(version));
          if (window.caches) {
            const keys = await caches.keys();
            await Promise.all(keys.map((key) => caches.delete(key)));
          }
          window.location.reload();
        }
      } catch (error) {
        // build.json is absent in development; ignore.
      }
    };

    check();
    const id = setInterval(check, duration);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, [duration, filename]);
}
